import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldTextareaComponent } from './form-field-textarea.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';


@NgModule({
  declarations: [
    FormFieldTextareaComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
    FormFieldTextareaComponent
  ]
})
export class FormFieldTextareaModule { }
